/**
 * Shared-layout identifiers + timing for the header search bar ⇄ ⌘K palette
 * morph (TAS-3542). The header bar and the palette's input row each render a
 * `motion` element carrying the SAME `layoutId`, so `motion` promotes the bar
 * from the header into the modal (and back) as one continuous element — position,
 * size, and radius interpolated by the library, with real interruption handling.
 * No hand-rolled rect math, no FLIP ghost.
 */
export const SEARCH_BAR_LAYOUT_ID = 'global-search-bar';
export const SEARCH_ICON_LAYOUT_ID = 'global-search-icon';

// One spring shared by both sides so the morph reads identically whichever end
// initiates it. Tuned to settle in ~0.25s — snappy, not floaty.
export const SEARCH_BAR_TRANSITION = { type: 'spring', stiffness: 560, damping: 46, mass: 1 } as const;

// Reduced-motion path: an instant cut, no transform/opacity tweening.
export const SEARCH_BAR_NO_MOTION = { duration: 0 } as const;
